/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';

import { FORM_FIELD } from './constants';

const Item = ({ className, module, previewImg, errors }) => {
  return (
    <InfoItem.WithError
      error={errors}
      size="large"
      image={previewImg}
      description={pluralize(module.content[FORM_FIELD.LOCATIONS.name].length, 'location')}
    >
      Interactive map
    </InfoItem.WithError>
  );
};

export default Item;
